import React, { useState } from "react";
import styles from './BtTable.module.scss';
import Button from "../button/Button";
import PropTypes from "prop-types";
import Icon from "../icon/Icon";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";
import {ReactComponent as XIcon} from './X.svg';

const BtTable = ({
  data,
  onCancel,
  isAcknowledged = false,
  onAcknowledge = () => {}
}) => {
  const [showFepraContent, setShowFepraContent] = useState(false);

  if(!data) {
    return <LoadingSpinner size={20} />;
  }
  
  return (
    <div className={styles.container}>
      {isAcknowledged && <div className={styles.close}>
        <XIcon onClick={() => onCancel()}/>
      </div>}
      <div className={styles.title}>
        <Icon name="award-bold" />
        <span>Benchmarks and Threshold</span>
      </div>
      {data?.headings && data?.successData && <div className={styles.section}>
        <p className={styles.description}>
          The table below outlines benchmarks for evaluating student performance based on <b>success rate </b> 
          relative to expectations (proficient) to where the student is in their matriculation.
        </p>
        <div className={styles.table}>
          <table>
            <thead>
              <tr>
                <th className={styles.sticky}></th>
                {data.headings.map(({key, value}) => 
                  <th className={styles[key] ?? ''} key={`success-th-${key}`}>
                    {value}
                  </th>)}
              </tr>
            </thead>
            <tbody>
              {data.successData.map((item) => <tr key={`success-th-${item.title}`}>
                <td className={styles.sticky}>{item.title}</td>
                {data.headings.map(({key}) => <td key={`success-td-${key}`}>{item[key]}</td>)}
              </tr>)}
            </tbody>
          </table>
        </div>
      </div>}
      {data?.headings && data?.technicalData && <div className={styles.section}>
        <p className={styles.description}>
          The table below outlines benchmarks for evaluating student performance based on <b>technical assistance </b>
          required relative to expectations (proficient) to where the student is in their matriculation.
        </p>
        <div className={styles.table}>
        <table>
            <thead>
              <tr>
                <th className={styles.sticky}></th>
                {data.headings.map(({key, value}) => 
                  <th className={styles[key] ?? ''} key={`success-th-${key}`}>
                    {value}
                  </th>)}
              </tr>
            </thead>
            <tbody>
              {data.technicalData.map((item) => <tr key={`success-th-${item.title}`}>
                <td className={styles.sticky}>{item.title}</td>
                {data.headings.map(({key}) => <td key={`success-td-${key}`}>{item[key]}</td>)}
              </tr>)}
            </tbody>
          </table>
        </div>
      </div>}
      <div className={styles.section}>
        <p className={styles.description}>
          The Family Educational Rights and Privacy Act of 1974 (FERPA) contains several provisions 
          that are important to students such as access to educational files, the release of personally 
          identifiable records, directory information and transcripts. It is important to understand that 
          the FERPA Act protects student data from unlawful use and disclosure. Be respectful with student 
          information, including their clinical progress. For more information, use the link below.
        </p>
        <span className={styles.link} onClick={() => setShowFepraContent(!showFepraContent)}>
          Click here to {showFepraContent ? 'hide' : 'show'} Interpretation of FERPA
        </span>
        {showFepraContent && <p className={styles.description}>
          FERPA affords the student the right to consent to disclosures of personally identifiable information 
          contained in the student’s educational records, except to the extent that FERPA authorizes 
          disclosure without consent. One exception, which permits disclosure without consent, is disclosure 
          to school officials with legitimate educational interests. A school official is defined as a person 
          employed by the university in an administrative, supervisory, academic, or support staff position 
          (including law enforcement unit and health staff); a person or company with whom the university has 
          contracted (such as an attorney, auditor, consultant, or collection agent); a person serving on the 
          Board of Trustees; or assisting another school official in performing his or her tasks. A school 
          official has a legitimate educational interest if the official needs to review an education record 
          in order to fulfill his or her professional responsibility. Upon request, the university may disclose 
          education records without consent to officials. The university may also disclose education records to 
          organizations conducting studies for educational agencies or institutions under certain circumstances.
        </p>}
      </div>
      {!isAcknowledged && <div className={styles.actions}>
        <Button
          label="Cancel"
          variant="secondary"
          onClick={onCancel}
        />
        <Button
          label={isAcknowledged ? 'Acknowledged' : 'I Acknowledge'}
          variant="primary" 
          onClick={onAcknowledge}
          disabled={isAcknowledged}
        />
      </div>}
    </div>
  );
};

BtTable.propTypes = {
  data: PropTypes.shape({
    headings: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      })
    ).isRequired,
    successData: PropTypes.arrayOf(
      PropTypes.object
    ).isRequired,
    technicalData: PropTypes.arrayOf(
      PropTypes.object
    ).isRequired,
  }),
  onCancel: PropTypes.func.isRequired,
  isAcknowledged: PropTypes.bool,
  onAcknowledge: PropTypes.func
}

export default BtTable;